<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="icon-spin">
                <div class="house1"></div>
                <div class="house2"></div>
                <div class="house3"></div>
            </div>
            <div class="str-loarding">
                <span class="kei">計</span>
                <span class="san">算</span>
                <span class="chu">中</span>
            </div>
        </div>
    </div>
</template>


<script>
/**
 * 計算実行中のモーダル（家がくるくる回るやつ）
 * 計算部分で表示を制御しているため、CSSでのアニメーション以外は制御していない
 */
export default {
    name:"ModalLoadingSpin",
}
</script>

<style lang="scss" scoped>
div.modal-dialog{
    display: block;
    width: 100%;
    height: 100%;
    min-height: 80vh;
    padding: 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    overflow: hidden;
    -ms-overflow-style:none;
    top: 0;
    z-index: 9999;
    transition: all .3s ease;
}
.modal-content{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 300px;
    max-height: 300px;
    margin:  65px auto;
    padding: 1em 4em;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 5px 15px 2px rgba(0, 0, 0, 0.5);
    .icon-spin{
        width: 400px;
        padding: 20px;
        -webkit-animation:rotateY 2s linear 0s infinite;
        -moz-animation:rotateY 2s linear 0s infinite;
        animation:rotateY 2s linear 0s infinite;
        .house1{
            display: block;
            width: 60px;
            height: 0;
            margin: 0 auto;
            border-left: 50px solid transparent;
            border-right: 50px solid transparent;
            border-bottom: 50px solid #ccc;
        }
        .house2{
            display: block;
            width: 120px;
            height: 50px;
            margin: 0 auto;
            background-color: #ccc;
            position: relative;
        }
        .house2:before{
            content:"";
            display: block;
            width: 20px;
            height: 30px;
            background-color: white;
            bottom: 0;
            left: 20px;
            position: absolute;
        }
        .house3{
            display: block;
            width: 120px;
            height: 50px;
            margin: 0 auto;
            background: linear-gradient(#ddd, transparent);
        }
        @keyframes rotateY {
            0% {
                -webkit-transform:rotateY(0deg);
                -moz-transform:rotateY(0deg);
                transform:rotateY(0deg);
            }
            30% {
                -webkit-transform:rotateY(45deg);
                -moz-transform:rotateY(45deg);
                transform:rotateY(45deg);
            }
            100% {
                -webkit-transform:rotateY(360deg);
                -moz-transform:rotateY(360deg);
                transform:rotateY(360deg);
            }
        }
    }
}
.str-loarding span{
    display: inline-block;
    margin: 0 -.05em;
    font-size: 30px;
    letter-spacing: 0.5em;
    color: #999;
    animation: key1 .3s ease infinite alternate;
    .str-loarding span:nth-child(0) {
        animation-delay: .1s;
    }
    .str-loarding span:nth-child(1) {
        animation-delay: .2s;
    }
    .str-loarding span:nth-child(2) {
        animation-delay: .3s;
    }
    @keyframes key1{
        0% {transform: translateY(0px);}
        100% {transform: translateY(-10px);}
    }
}
</style>


